import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const Background = styled.div`
  width: 25px;
  height: 25px;
  background-color: ${({ color }) => color};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
